import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { localStorageHandler } from 'core/services';
import { action } from 'mobx';
import { isSuperAdminOrganization } from 'core/utils';

class CloseOutDetailViewStore extends BaseViewStore {
	data = [];
	warehouse = null;
	noDataItem = true;
	superAdminWarehouse = '';

	constructor(rootStore) {
		super(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		this.tableData = {
			columns: [
				{
					key: 'fulfillmentOrderId',
					title: 'CLOSEOUTDETAILVIEW.TABLE.FULFILLMENTORDERID',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'fulfillmentOrderStatus.name',
					title: 'CLOSEOUTDETAILVIEW.TABLE.FULFILLMENTORDERSTATUS',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'onHoldReason.name',
					title: 'CLOSEOUTDETAILVIEW.TABLE.ONHOLDREASON',
					selected: true,
					width: 200,
					filter: null,
				},
			],
			actions: {},
			sortObject: [],
		};
		this.warehouse = await this.applicationStore.getOrganizationInfo();
		if (isSuperAdminOrganization(this.rootStore)) {
			this.superAdminWarehouse = localStorageHandler.get('closeOutWarehouse').label;
		}

		this.data = await this.fulfillmentOrderStore.getCloseoutOrders({
			embed: ['fulfillmentOrderStatus', 'onHoldReason'],
			isCloseOutPalletizing: localStorageHandler.get('isCloseOutPalletizing'),
			warehouseId: isSuperAdminOrganization(this.rootStore) ? localStorageHandler.get('closeOutWarehouse').value : null,
		});
		this.resume();
	}
}

export default CloseOutDetailViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/CloseOutDetailViewStore.js